/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
==========================================================================================*/


const mutations = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    UPDATE_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },
    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
        state.sidebarItemsMin = val;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val;
    },
    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },
    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },
    UPDATE_THEME(state, val) {
        state.theme = val;
    },
    UPDATE_WINDOW_BREAKPOINT(state, val) {
        state.breakpoint = val;
    },
    UPDATE_PRIMARY_COLOR(state, val) {
        state.themePrimaryColor = val;
    },
    UPDATE_STATUS_CHAT(state, value) {
        state.appActiveUser.status = value;
    },
    UPDATE_ACTIFCLIENT(state, value) {
        state.actifClient = value;
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    UPDATE_STARRED_PAGE(state, payload) {
        // find item index in search list state
        const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index);
        // update the main list
        state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

        // if val is true add it to starred else remove
        if (payload.val) {
            state.starredPages.push(state.navbarSearchAndPinList.data[index]);
        } else {
            // find item index from starred pages
            const index = state.starredPages.findIndex((item) => item.index == payload.index);
            // remove item using index
            state.starredPages.splice(index, 1);
        }
    },
    HasSignedIn(state, val) {
        state.isSignedIn = val;
    },
    RememberMe(state, val) {
        state.rememberMe = val;
    },
    HasSingleSignedIn(state, val) {
        state.isSingleSignedIn = val;
    },
    InviteId(state, val) {
        state.inviteId = val;
    },
    SmsCodeVal(state, val) {
        state.smsCodeVal = val;
    },
    HasConjoint(state, val) {
        state.hasConjoint = val;
    },
    SET_Cognito_User(state, payload) {
        state.cognitoUser = payload;
    },
    // The Navbar
    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
        const starredPagesMore = state.starredPages.slice(10);
        state.starredPages = list.concat(starredPagesMore);
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
        let downToUp = false;
        let lastItemInStarredLimited = state.starredPages[10];
        const starredPagesLimited = state.starredPages.slice(0, 10);
        state.starredPages = starredPagesLimited.concat(list);

        state.starredPages.slice(0, 10).map((i) => {
            if (list.indexOf(i) > -1) downToUp = true;
        });
        if (!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited);
        }
    },
    SET_IS_SUPERADMIN(state, payload) {
        state.appActiveUser.isSuperAdmin = payload;
    },
    SET_IS_DOCREGADMIN(state, payload) {
        state.appActiveUser.isDocRegAdmin = payload;
    },
    SET_IS_EXPERTIMMO(state, payload) {
        state.appActiveUser.isImmoExpert = payload;
    },
    SET_USER_INFO(state, payload) {
        state.appActiveUser.id = payload.id;
        state.appActiveUser.name = payload.fullName;
        state.appActiveUser.email = payload.email;
        state.appActiveUser.tenantName = payload.tenantName;
        state.appActiveUser.isMultiTenant = payload.isMultiTenant;
        state.appActiveUser.lastConnetion = payload.lastConnetion;
        state.appActiveUser.lastIP = payload.lastIP;
        //state.appActiveUser.isSuperAdmin = payload.isSuperAdmin;
        state.appActiveUser.img = process.env.VUE_APP_BASE_API2_URL + "/Upload/logos/" + payload.logo;
    },
};

export default mutations;